"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useGetSchema = void 0;
var _zod = require("zod");
var _useTranslations_simplifiedRegistrationBrandPartner = require("../../../hooks/useTranslations_simplified-registration-BrandPartner");
var _utils = require("../../../utils");
const useGetSchema = (config, isSponsorNumberRequired) => {
  const {
    formatMessage
  } = (0, _useTranslations_simplifiedRegistrationBrandPartner.useTranslations)();
  if (!config) {
    return _zod.z.object({});
  }
  const {
    sponsorNumber,
    address
  } = config;
  let schema = _zod.z.object({});
  schema = _zod.z.object({
    sponsorNumber: (0, _utils.createFieldSchema)(formatMessage, {
      ...sponsorNumber,
      validation: {
        ...sponsorNumber?.validation,
        isMandatory: isSponsorNumberRequired
      }
    }, 'string'),
    address: _zod.z.object({
      addressType: (0, _utils.createFieldSchema)(formatMessage, address?.addressType, 'string'),
      zipcode: (0, _utils.createFieldSchema)(formatMessage, address?.zipcode, 'string'),
      country: (0, _utils.createFieldSchema)(formatMessage, address?.country, 'string')
    }).nullish()
  });
  return schema;
};
exports.useGetSchema = useGetSchema;